import React, { FC } from 'react';
import { AgentThread, Agent } from '@dreamai/types';
import { ReactComponent as BrainIcon } from '../../../icons/brain.svg';
import './inner-monologue-thread-button.scss';

interface BackgroundThreadButtonProps {
  threads: AgentThread[];
  selectedThreadId?: string | null;
  onThreadSelect: (threadId: string, agentId?: string) => void;
  visible: boolean;
}

const BackgroundThreadButton: FC<BackgroundThreadButtonProps> = ({
  threads,
  selectedThreadId,
  onThreadSelect,
  visible,
}) => {
  // Get the thread (should only be one passed in)
  const thread = threads[0];

  if (!thread) return null;

  // Format the thread date/time
  const formatThreadTime = (dateString: string): string => {
    const date = new Date(dateString);
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const threadDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
    );

    // If today, just show time
    if (threadDate.getTime() === today.getTime()) {
      return date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      });
    }

    // Otherwise show full date with time
    const dayName = date.toLocaleDateString('en-GB', { weekday: 'short' });
    const day = date.getDate();
    const month = date.toLocaleDateString('en-GB', { month: 'long' });
    const year = date.getFullYear();
    const time = date.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    });

    return `${dayName}, ${day} ${month} ${year}. ${time}`;
  };

  return (
    <li className={`inner-monologue-wrapper ${visible ? 'visible' : ''}`}>
      <a
        href={`?agent_id=${thread.agent_id}&thread_id=${thread.id}`}
        className={`inner-monologue-thread ${selectedThreadId === thread.id ? 'active' : ''}`}
        onClick={(e) => {
          // Only prevent default if not opening in new tab
          if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button === 0) {
            e.preventDefault();
            onThreadSelect(thread.id, thread.agent_id);
          }
        }}
      >
        <div className='text-wrapper'>
          <div className='thread-title'>
            <BrainIcon className='brain-icon' />
            {thread.description || 'Background Thread'}
          </div>
          <div className='thread-time'>
            {formatThreadTime(thread.last_updated_at)}
          </div>
        </div>
      </a>
    </li>
  );
};

export default BackgroundThreadButton;
